import React from "react";

import "./loader.css";

const Loader = ({ loader = false }) => {
  return loader ? <span class="loader"></span> : null;
};

export default Loader;
